import React from "react";
import Moment from "react-moment";
import { Link, useParams } from "react-router-dom";
import { BsChevronRight } from "react-icons/bs";
import { ItemTitle } from "../../../commons/elements";
import orderItem from "../../../prop-types/orderItem";
import { ACCOUNT, ORDER_DETAILS } from "../../../constants";

function OrderItem(props) {
  const { item } = props;
  const params = useParams();

  return (
    <div className="order-item d-flex my-3">
      <div className="product-data pr-4">
        <div className="date-purchased">
          <Moment format="MMM. DD, YYYY">{item.date}</Moment>
        </div>
        <div className="produc-name-container my-2">
          <ItemTitle title={item.name} />
        </div>
        <div className="product-price-container my-1">
          <span className="product-price">
            ${item.price === 0 ? 0 : (item.price / 100).toFixed(2)}
            {item.refunded ? " *" : ""}
          </span>
        </div>
      </div>
      <div className="order-navigation ml-auto d-flex justify-content-center align-items-center">
        <Link
          to={`/${params.shortName}/${ACCOUNT}/${ORDER_DETAILS}/${item.id}`}
        >
          <BsChevronRight />
        </Link>
      </div>
    </div>
  );
}

OrderItem.propTypes = {
  item: orderItem.isRequired
};

export default OrderItem;
